const getCurrencyConversionRates = (currencyConversionUnits) => {
  return {
    CAD: {
      USD: currencyConversionUnits?.USD,
      NGN: currencyConversionUnits?.NGN,
      CAD: 1
    },
    NGN: {
      USD: currencyConversionUnits?.USD / currencyConversionUnits?.NGN,
      CAD: currencyConversionUnits?.CAD / currencyConversionUnits?.NGN,
      NGN: 1
    },
    USD: {
      CAD: currencyConversionUnits?.CAD / currencyConversionUnits?.USD,
      NGN: currencyConversionUnits?.NGN / currencyConversionUnits?.USD,
      USD: 1
    }
  };
};

export {
  getCurrencyConversionRates
};